module.exports = __webpack_public_path__ + "static/media/edit-blue.c080e54d.svg";